// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__4q-ma","insightsList":"newBusinessInsightsMenu_insightsList__3Sax8","active":"newBusinessInsightsMenu_active__3vdAQ"};